import React from 'react';
import { Link } from 'react-router-dom';
import hosp from '../assets/Hospitalitysmall.png';

const Hospitality = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh', padding: '40px' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>Hospitality WiFi Solutions</h1>

        <img src={hosp} alt="Hospitality WiFi" style={{
          width: '100%', maxWidth: '600px', borderRadius: '12px', marginBottom: '30px'
        }} />

        <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '24px', fontSize: '1.1rem' }}>
          Hospitality WiFi has evolved from a perk to an essential amenity. With guests averaging
          2.9 personal devices each, ensuring seamless connectivity throughout their stay is
          paramount. Any shortcomings in WiFi service directly impact guest satisfaction and your
          property's reputation.
        </p>

        <h2 style={{ fontSize: '1.8rem', marginBottom: '16px' }}>Cloud-Managed Guest WiFi</h2>
        <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '24px', fontSize: '1.1rem' }}>
          Sarvanta delivers cloud-managed hospitality WiFi solutions designed for the demands of
          modern guests. Our platform provides exceptionally fast speeds, premium in-room
          entertainment support, and enhances the competitiveness and profitability of your business.
          Managed in real-time, our solutions proactively address service issues and ensure guest
          satisfaction across all your properties.
        </p>

        <h2 style={{ fontSize: '1.8rem', marginBottom: '16px' }}>Personal Area Networks</h2>
        <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '40px', fontSize: '1.1rem' }}>
          Each guest receives their own Personal Area Network (PAN), providing a safer and more
          user-friendly experience than typical shared networks. With automatic authentication,
          guests enjoy secure, encrypted access to their individual PAN — both within their room
          and across the entire property.
        </p>

        <h2 style={{ fontSize: '1.8rem', marginBottom: '24px' }}>Why Sarvanta for Hospitality</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginBottom: '40px' }}>
          {[
            { title: 'Guest Satisfaction', desc: 'Reliable, high-speed WiFi across every room, lobby, pool area, and conference space.' },
            { title: 'Real-Time Management', desc: 'Proactively identify and resolve connectivity issues before guests notice them.' },
            { title: 'Multi-Property Control', desc: 'Manage WiFi across all your properties from a single cloud dashboard.' },
            { title: 'Revenue Opportunities', desc: 'Tiered bandwidth plans and premium connectivity options create new revenue streams.' }
          ].map((item, i) => (
            <div key={i} style={{
              padding: '24px', backgroundColor: '#0a1628', borderRadius: '10px',
              border: '1px solid #1a2744'
            }}>
              <h3 style={{ fontSize: '1.1rem', marginBottom: '8px', color: '#60a5fa' }}>{item.title}</h3>
              <p style={{ color: '#a0aec0', lineHeight: '1.6', margin: 0, fontSize: '0.95rem' }}>{item.desc}</p>
            </div>
          ))}
        </div>

        <div style={{ padding: '24px', backgroundColor: '#0a1628', borderRadius: '10px', border: '1px solid #1a2744', textAlign: 'center' }}>
          <p style={{ color: '#a0aec0', marginBottom: '16px' }}>
            Learn how Sarvanta revolutionizes hospitality connectivity.
          </p>
          <Link to="/whitepapers" style={{
            padding: '12px 28px', backgroundColor: '#2563eb', color: '#fff',
            borderRadius: '8px', textDecoration: 'none', fontWeight: '600'
          }}>Download White Paper</Link>
        </div>
      </div>
    </div>
  );
};

export default Hospitality;
